import React from 'react';
import { C } from './estilos';
import { Interruptor } from './ListaAjustes';

/**
 * Columna derecha: "Qué cambia con este ajuste". Muestra el chat de ejemplo
 * del switch elegido, prendido y apagado, y marca cuál es el de hoy.
 */

const NOMBRE = { lead: 'Lead', bot: 'Aria', sistema: '' };

export const Burbuja = ({ burbuja }) => {
  const { de, texto, etiqueta, botones } = burbuja;
  const esLead = de === 'lead';
  const esSistema = de === 'sistema';
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: esLead ? 'flex-end' : (esSistema ? 'stretch' : 'flex-start') }}>
      {(NOMBRE[de] || etiqueta) && (
        <div style={{ display: 'flex', gap: 8, alignItems: 'baseline', fontSize: 11.5 }}>
          {NOMBRE[de] && <span style={{ fontWeight: 600, color: C.ink2 }}>{NOMBRE[de]}</span>}
          {etiqueta && <span style={{ color: C.gris, fontStyle: 'italic' }}>{etiqueta}</span>}
        </div>
      )}
      <div
        style={{
          maxWidth: esSistema ? '100%' : '88%', borderRadius: 14, padding: '8px 12px',
          fontSize: 13.5, lineHeight: 1.45, whiteSpace: 'pre-line', overflowWrap: 'anywhere',
          background: esLead ? '#fff' : (esSistema ? 'transparent' : C.mentaBurbuja),
          border: `1px ${esSistema ? 'dashed' : 'solid'} ${esLead ? C.linea : (esSistema ? C.apagado : 'transparent')}`,
          color: esSistema ? C.ink2 : C.ink, fontStyle: esSistema ? 'italic' : 'normal',
        }}
      >
        {texto}
        {botones && botones.length > 0 && (
          <div style={{ marginTop: 8, display: 'flex', gap: 6, flexWrap: 'wrap', fontStyle: 'normal' }}>
            {botones.map((b) => (
              <span key={b} style={{ border: `1px solid ${C.cyan}`, color: C.steel, borderRadius: 25, padding: '2px 11px', fontSize: 12.5, background: '#fff' }}>{b}</span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export const BloqueEstado = ({ prendido, actual, item }) => {
  const burbujas = (prendido ? item.chat?.on : item.chat?.off) || [];
  const etiqueta = prendido ? 'Si está prendido' : 'Si está apagado';
  return (
    <div
      aria-label={etiqueta}
      data-actual={actual ? 'si' : 'no'}
      style={{
        borderRadius: 16, padding: 14, display: 'flex', flexDirection: 'column', gap: 10,
        background: C.fondo, border: `1.5px solid ${actual ? C.menta : C.linea}`,
        opacity: actual ? 1 : 0.62, transition: 'opacity 300ms, border-color 300ms',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
        <span style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 13, fontWeight: 600, color: C.ink }}>
          <Interruptor on={prendido} tamano="chico" />{etiqueta}
        </span>
        {actual && (
          <span style={{ fontSize: 12, color: C.verde, fontWeight: 600, display: 'flex', gap: 4, alignItems: 'center' }}>
            <i className="pi pi-check" style={{ fontSize: 11 }} />Así queda ahora
          </span>
        )}
      </div>
      {burbujas.map((b, i) => <Burbuja key={`${b.de}-${i}`} burbuja={b} />)}
    </div>
  );
};

export const PanelCambio = ({ item, on, botApagado }) => {
  if (!item) return null;
  return (
    <aside
      aria-label="Qué cambia con este ajuste"
      style={{ background: '#fff', borderRadius: 16, display: 'flex', flexDirection: 'column', border: `1px solid ${C.lineaSuave}`, minHeight: 0 }}
    >
      <div style={{ padding: '14px 18px 12px', display: 'flex', flexDirection: 'column', gap: 7, borderBottom: `1px solid ${C.lineaSuave}` }}>
        <span style={{ fontSize: 11.5, letterSpacing: '0.06em', textTransform: 'uppercase', color: C.verde, fontWeight: 600 }}>
          Qué cambia con este ajuste
        </span>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <h3 style={{ margin: 0, fontSize: 17, fontWeight: 600, color: C.steel }}>{item.titulo}</h3>
          <span
            style={{
              fontSize: 12, fontWeight: 600, borderRadius: 10, padding: '1px 10px',
              color: on ? C.verde : C.gris, border: `1px solid ${on ? C.menta : C.apagado}`,
            }}
          >
            {on ? 'Prendido' : 'Apagado'}
          </span>
        </div>
        {botApagado && item.clave !== 'ENABLED' && (
          <span style={{ fontSize: 12.5, color: C.naranjaTexto, display: 'flex', gap: 6, alignItems: 'center' }}>
            <i className="pi pi-power-off" style={{ fontSize: 11 }} />El bot está apagado: hoy nada de esto se manda.
          </span>
        )}
      </div>
      <div style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 12 }}>
        <BloqueEstado prendido actual={on} item={item} />
        <BloqueEstado prendido={false} actual={!on} item={item} />
      </div>
    </aside>
  );
};

export default PanelCambio;
